import { Formik } from 'formik';

import { AuthRequestAuthCodePayload } from 'modules/auth/domain/interfaces/auth-request-auth-code-payload';
import React from 'react';
import { useLingui } from '@lingui/react/macro';
import { getPhonePrefix, ValidPhoneCode } from 'ud-form/components/input/domain/formatters/format-phone';
import UDInputPhone from 'ud-form/components/input/phone';
import UDButton from 'ud-ui/components/button';
import { SchemaOf } from 'yup';

type RequestAuthCodeFormProps = {
  initialValues: {
    phone: string;
  };
  /** Возвращает промис запроса кода: «Отправить код» заперта до ответа (IMGM-1561). */
  onSubmit: (values: AuthRequestAuthCodePayload) => Promise<unknown>;
  validationSchema?: SchemaOf<AuthRequestAuthCodePayload>;
};

const isPhoneComplete = (phone: string, prefix: ValidPhoneCode): boolean => {
  const digitsOnly = phone.replace(/\D/g, '');

  switch (prefix) {
    case '+7':
      return digitsOnly.slice(0, 11).length === 11;
    case '+375':
      return digitsOnly.slice(0, 12).length === 12;
    case '+374':
      return digitsOnly.slice(0, 11).length === 11;
    default:
      return false;
  }
};

const RequestAuthCodeForm = (props: RequestAuthCodeFormProps) => {
  const { t } = useLingui();

  return (
    <Formik<AuthRequestAuthCodePayload>
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={props.validationSchema}
    >
      {(formProps) => {
        // TODO: зачем отдельная функция на получение префикса, если можно её вызывать внутри isPhoneComplete?
        const prefix = getPhonePrefix(formProps.values.phone);
        const isComplete = isPhoneComplete(formProps.values.phone, prefix);

        return (
          <form onSubmit={formProps.handleSubmit}>
            <UDInputPhone
              autoFocus
              name="phone"
              label={t`Номер телефона`}
              placeholder={t`номер телефона`}
              wrapperProps={{ className: 'mb-4.5' }}
              value={formProps.values.phone}
              onChange={(value: string) => {
                formProps.setFieldValue('phone', value);
                if (isComplete) {
                  formProps.validateField('phone');
                }
              }}
            />
            <UDButton
              variant="primary"
              type="submit"
              className="w-full"
              style={{ fontFamily: 'SF Pro Display', fontWeight: 400 }}
              disabled={!isComplete || !formProps.isValid || !formProps.dirty}
            >
              {t`Отправить код`}
            </UDButton>
          </form>
        );
      }}
    </Formik>
  );
};

export default RequestAuthCodeForm;
